module.exports = __webpack_public_path__ + "img/national-park.ae30870d.webp";